import React from 'react';

import {LockClosedIcon} from '@ergeon/icons/hero/outline';

import {Button, Card} from '@ergeon/core-components';
import AuthProvider from './AuthProvider';
import SessionExpiredNotice from './SessionExpiredNotice';
import {AuthProps} from './types';

/**
 * Displays our authentication UI, if auth was successful (we have the user) we render the children
 * with our user data inside
 */
function Auth(props: AuthProps) {
  const {
    authService,
    children,
    title = 'Login to Ergeon',
    btnTitle = 'Login using Ergeon ID',
    note = 'You will be redirected to the login page',
    ...divProps
  } = props;

  return (
    <AuthProvider authService={authService}>
      {({user, sessionNoticeVisible, signInProgress, onAuth, onDismissSessionNotice}) => {
        if (user) {
          return (
            <>
              {sessionNoticeVisible && (
                <SessionExpiredNotice
                  onAuth={onAuth}
                  onDismiss={onDismissSessionNotice}
                  signInProgress={signInProgress}
                />
              )}
              {children(user)}
            </>
          );
        }
        return (
          <div className="flex flex-col justify-center items-center gap-3 h-screen">
            <Card
              className="max-w-xs flex flex-col justify-center items-center gap-3 p-10 text-center"
              data-testid="erg-auth-card"
              zIndex="2"
              {...divProps}
            >
              <LockClosedIcon className="size-10 text-orange-500" />
              <h1 className="text-gray-900 dark:text-white heading-4">{title}</h1>
              <div className="flex flex-col justify-center items-center gap-2">
                <Button onClick={onAuth} size="large">
                  {btnTitle}
                </Button>
                <i className="text-gray-600 dark:text-gray-400 paragraph-3">{note}</i>
              </div>
            </Card>
          </div>
        );
      }}
    </AuthProvider>
  );
}

export default Auth;
